export default {
  menuId:0,
  menuOrder:'',
  menuNameSp:'',
  menuNameEn:'',
  menuNamePr:'',
  menuRoute:'',
  menuParam:'',
  menuIcon:'',
  menuIsAdmin:'',
  menuParent:0,
  menuStatus:''
}
